module.exports = __webpack_public_path__ + "static/media/price-list.e0c36c28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Partner/imgs/price-list.jpg
// module id = 1518
// module chunks = 0